import Ogolne from './Ogolne';

const pageComponents = {
  Ogolne
};

export default pageComponents;
